import typography from "../typography";

export default {
  root: {
    minWidth: 45
  },
};
